import type { IconCard } from './types';

export const qualityContent = {
    sectionTitle: 'Unwavering Standards. Total Transparency.',
    factors: [
        {
            icon: 'award',
            title: 'Halal Integrity',
            description: 'Halal integrity is the cornerstone of Brilliance Solutions. Through strict oversight, elite global partnerships, and flawless cold-chain logistics, we guarantee uncompromised purity and exceptional quality from pasture to table',
        },
        {
            icon: 'shield-check',
            title: 'Compliance',
            description: 'Compliance and strict health benchmarks define our reputation. Brilliance Solutions ensures absolute adherence to SFDA mandates, executing exhaustive quality controls to safeguard public health',
        },
        {
            icon: 'snowflake',
            title: 'Cold-Chain Tech',
            description: 'Powered by advanced temperature-controlled logistics, Brilliance Solutions utilizes real-time tracking and continuous thermal monitoring to guarantee flawless freshness and safety from origin to delivery',
        },
    ] satisfies IconCard[],
};
